"use client";

import React from "react";

type MinorSkill = {
  minorSkillName: string;
  minorSkillState: string;
};

type SkillProps = {
  skillProps: {
    skillName: string;
    skillDescription: string;
    skillSet: Array<MinorSkill>;
  };
};

export function SkillSet({ skillProps }: SkillProps) {
  return (
    <div className="flex-1 flex flex-col gap-5 p-10 rounded-lg bg-secondary-grey min-w-xs">
      <div className="flex flex-col flex-nowrap">
        <h2>{skillProps.skillName}</h2>
        <p>{skillProps.skillDescription}</p>
      </div>

      <ul className="flex flex-col gap-5">
        {skillProps.skillSet.map((skill, index) => (
          <li
            key={index}
            className="flex flex-col justify-start items-start w-full"
          >
            <span className="text-white text-sm font-medium text-nowrap">
              {skill.minorSkillName}
            </span>
            <span className="text-primary-yellow text-sm font-semibold">
              {skill.minorSkillState}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
